import styled from 'styled-components';
import Stack from '@karma/components/Stack';
import { getColor } from '@karma/components/colors';

export const ImageBadge = styled(Stack)`
  position: absolute;
  z-index: 20;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 25px;
  background-color: ${getColor('neutral5')};
`;

export const OutOfStockOverlay = styled.div`
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${getColor('neutral1')}33;
`;

export const Discount = styled.div`
  padding: 1px 4px;
  border-radius: 0 2px 2px 0;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: ${getColor('neutral3')};
  background: ${getColor('neutral8')};
  position: absolute;
  left: 0;
  bottom: 23px;
`;
